import { z } from "zod";

import { listSearchBaseShape, searchTextSchema } from "/src/router/searchSchemas";

export const adminListSearchSchema = z.object({
  ...listSearchBaseShape,
  name: searchTextSchema,
  id: searchTextSchema,
  detailStatus: z.enum(["add", "edit", "detail", "addOrgAdmin"]).optional().catch(undefined),
});

export type AdminSearch = z.infer<typeof adminListSearchSchema>;

export const adminListSearchFields = ["name"] as const;

export type AdminListSearchField = (typeof adminListSearchFields)[number];
export type AdminListSearchFormValues = Pick<AdminSearch, AdminListSearchField>;

function createAdminSearchValues(
  getValue: (field: AdminListSearchField) => string | undefined,
): AdminListSearchFormValues {
  return adminListSearchFields.reduce((values, field) => {
    values[field] = getValue(field);
    return values;
  }, {} as AdminListSearchFormValues);
}

export const emptyAdminListSearch = createAdminSearchValues(() => undefined);

export function getAdminSearchValues(search: AdminSearch): AdminListSearchFormValues {
  return createAdminSearchValues((field) => search[field]);
}

export function getAdminSearchPatch(
  values: Partial<Record<AdminListSearchField, string | undefined>>,
): AdminListSearchFormValues {
  return createAdminSearchValues((field) => values[field] || undefined);
}
